<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">II.</h3>
<p class="calibre1">Diese strenge Lehre fand eine gerüstete Seele, die von Natur zur
Pflicht hinneigte, und die das Beispiel meines Vaters und meiner
Mutter im Verein mit der puritanischen Zucht, der sie die ersten
Aufschwünge meines Herzens unterworfen hatten, vollends zu dem
geneigt machten, was ich »die Tugend« nennen hörte. Es war mir
ebenso natürlich, mich zu zwingen, wie es anderen natürlich ist,
sich gehen zu lassen; und diese Strenge, der man mich unterwarf,
schmeichelte mir, statt mich abzustoßen. Ich verlangte von der
Zukunft nicht so sehr das Glück wie vielmehr das unendliche Streben
nach ihm; und schon verwechselte ich Glück und Tugend. Ohne Zweifel
war ich als ein Kind von vierzehn Jahren noch unentschieden,
biegsam; aber bald befestigte mich meine Liebe zu Alissa
entschlossen in diesem Sinne. Es war eine jähe innere Erleuchtung,
mit deren Hilfe ich mir meiner selbst bewußt wurde: ich erschien
<a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page34" title="ECeDee/Dieter7"></a> mir als in
mich zusammengezogen, wenig aufgeblüht, als voll Erwartung, als
wenig um andere bekümmert, als mittelmäßig unternehmend und als
einer, der von keinen Siegen träumt außer von denen, die man über
sich selbst davonträgt. Ich liebte das Studium; unter den Spielen
gewann ich nur die gern, die Sammlung oder Anstrengung verlangen.
Mit meinen Altersgenossen verkehrte ich wenig, und zu ihren
Vergnügungen gab ich mich nur aus Liebe oder Gefälligkeit her.
Immerhin schloß ich mich Abel Vautier an, der im folgenden Jahr
nach Paris zu mir in meine Klasse kam. Er war ein anmutiger, träger
Junge, für den ich mehr Neigung als Achtung spürte, mit dem ich
aber wenigstens von Le Havre und Fongueusemare reden konnte, wohin
mein Gedanke unablässig zurückflog.</p>
<p class="calibre1">Meinen Vetter Robert Bucolin, den man als Pensionär in dasselbe
Lyzeum gebracht hatte, in dem wir waren, aber zwei Klassen tiefer,
sah ich nur Sonntags. Wenn er nicht der Bruder meiner Kusinen
gewesen wäre, denen er übrigens wenig glich, so hätte es mir kein
Vergnügen gemacht, ihn zu sehen. <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page35" title="ECeDee/Dieter7"></a></p>
<p class="calibre1">Ich war damals ganz mit meiner Liebe beschäftigt, und nur in
ihrem Licht erhielten diese beiden Freundschaften für mich
irgendwelche Bedeutung. Alissa war jener kostbaren Perle gleich,
von der mir das Evangelium gesprochen hatte; ich war jener, der
alles verkauft, was er hat, um sie zu besitzen. So sehr ich noch
Kind war, tue ich Unrecht daran, von Liebe zu reden und die
Empfindung, die ich meiner Kusine entgegenbrachte, so zu nennen?
Nichts, was ich später kennenlernte, scheint mir dieses Namens
würdiger – und übrigens wandelte, als ich in das Alter kam, um
schärfer umrissene Nöte des Fleisches zu spüren, meine Empfindung
kaum ihr Wesen. Ich suchte sie, die ich als Kind nur zu verdienen
trachtete, nicht unmittelbarer zu besitzen. Arbeit, Anstrengungen,
fromme Werke: mystisch brachte ich alles Alissa dar; und ich erfand
mir darin ein Raffinement der Tugend, daß ich sie oft in
Unwissenheit über das ließ, was ich nur für sie getan hatte. Ich
berauschte mich so an einer Art zu Kopf steigender Entsagung und
gewöhnte mich, leider! indem ich wenig nach meinem Vergnügen
fragte, mit nichts mehr zufrieden zu sein, <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page36" title="ECeDee/TBeaker"></a> was mich nicht einige
Anstrengung gekostet hatte.</p>
<p class="calibre1">Spornte dieser Eifer nur mich? Es scheint mir nicht, als sei
Alissa für ihn empfänglich gewesen und als hätte sie etwas um
meinetwillen getan, während ich mich nur für sie mühte. Alles blieb
in ihrer ungekünstelten Seele von natürlichster Schönheit. Ihre
Tugend bewahrte soviel Leichtigkeit und Anmut, daß sie als ein
Sich-gehen-Lassen erschien. Infolge ihres kindlichen Lächelns war
der Ernst ihres Blickes bezaubernd; ich sehe es noch, wie dieser so
sanft, so zärtlich fragende Blick sich hebt, und ich verstehe, daß
mein Onkel in seiner Verwirrung bei seiner älteren Tochter Stütze,
Rat und Trost suchen konnte. Oft sah ich ihn in dem Sommer, der
folgte, mit ihr plaudern. Sein Kummer hatte ihn sehr gealtert; er
sprach bei den Mahlzeiten kaum noch, oder er zeigte bisweilen
unvermittelt eine Art gespielter Freude, die noch peinlicher war
als sein Schweigen. Er blieb in seinem Arbeitszimmer und rauchte
dort bis zu der Abendstunde, in der Alissa ihn aufsuchte; er ließ
sich bitten, wenn er ausgehen sollte; sie führte ihn wie ein Kind
in den Garten. Beide <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page37" title="ECeDee/TBeaker"></a> stiegen den Blumengang hinab und setzten sich
auf dem Rondell bei der Treppe zum Küchengarten, wohin wir Stühle
getragen hatten.</p>
<p class="calibre1">Eines Abends, als ich noch spät, im Schatten einer der großen
purpurnen Buchen auf dem Grase ausgestreckt, las, von dem
Blumengang nur durch die Lorbeerhecke getrennt, die die Blicke
hemmte, nicht aber die Stimmen – hörte ich Alissa und meinen Onkel.
Ohne Zweifel hatten sie von Robert gesprochen; da wurde von Alissa
mein Name ausgesprochen; und als ich eben ihre Worte zu
unterscheiden begann, rief mein Onkel aus:</p>
<p class="calibre1">»Oh, der wird stets die Arbeit lieben.«</p>
<p class="calibre1">Als Lauscher wider Willen wollte ich davongehen oder wenigstens
eine Bewegung machen, die ihnen meine Anwesenheit verriet; aber was
sollte ich tun? Husten? Rufen: »Ich bin da! Ich höre euch?« …
Und eher Scheu und Schüchternheit als die Begier, mehr zu
vernehmen, hielten mich still. Übrigens gingen sie nur vorüber, und
ich hörte sogar ihre Reden nur sehr unvollkommen … Aber sie
gingen langsam; ohne Zweifel hatte Alissa, wie sie es gewohnt war,
einen leichten Korb am Arm, nahm verwelkte <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page38" title="ECeDee/TBeaker"></a> Blumen fort und hob am Fuß der
Spaliere die noch grünen Früchte auf, die die häufigen Meeresnebel
zum Fallen brachten. Ich hörte ihre klare Stimme:</p>
<p class="calibre1">»Papa, war Onkel Palissier ein bedeutender Mann?« Die Stimme
meines Onkels war dumpf und verschleiert; ich konnte seine Antwort
nicht verstehen. Alissa beharrte: »Sehr bedeutend, sag?«</p>
<p class="calibre1">Von neuem zu verschwommene Antwort. Dann Alissa von neuem:</p>
<p class="calibre1">»Jerome ist intelligent, nicht wahr?« Wie hätte ich nicht das
Ohr hinstrecken sollen … aber nein, ich konnte nichts
unterscheiden. Sie fuhr fort:</p>
<p class="calibre1">»Glaubst du, daß er ein bedeutender Mann werden wird?«</p>
<p class="calibre1">Jetzt wurde die Stimme meines Onkels lauter:</p>
<p class="calibre1">»Aber, liebes Kind, ich möchte zunächst einmal wissen, was du
mit diesem Wort meinst. Bedeutend! Man kann sehr bedeutend sein,
ohne daß es danach aussieht, wenigstens für die Augen der
Menschen … sehr bedeutend in Gottes Augen.« <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page39" title="ECeDee/TBeaker"></a></p>
<p class="calibre1">»So meine ich es,« sagte Alissa.</p>
<p class="calibre1">»Und dann … kann man das jetzt schon wissen? Er ist noch zu
jung … Ja, gewiß, er verspricht viel; aber das genügt nicht
für den Erfolg …«</p>
<p class="calibre1">»Wessen bedarf es mehr?«</p>
<p class="calibre1">»Aber liebes Kind, was soll ich dir sagen? Man braucht
Zuversicht, Halt, Liebe …«</p>
<p class="calibre1">»Was nennst du Halt?« unterbrach Alissa ihn.</p>
<p class="calibre1">»Die Liebe und Achtung, die mir gefehlt haben,« erwiderte mein
Onkel traurig. Dann verlor sich ihre Stimme endgültig.</p>
<p class="calibre1">Im Augenblick meines Abendgebets packten mich Gewissensbisse
wegen meines unabsichtlichen Horchens, und ich nahm mir vor, mich
deswegen vor meiner Kusine anzuklagen. Vielleicht mischte sich
diesmal die Begierde, mehr zu erfahren, hinein.</p>
<p class="calibre1">Und bei den ersten Worten, die ich am folgenden Tage darüber
sprach:</p>
<p class="calibre1">»Aber Jerome, es ist sehr schlecht, so zu lauschen. Du hättest
uns warnen müssen oder fortgehen.« <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page40" title="ECeDee/TBeaker"></a></p>
<p class="calibre1">»Ich versichere dir, daß ich nicht gelauscht habe … Ich
hörte, ohne es zu wollen … Dann gingt ihr auch nur
vorüber …«</p>
<p class="calibre1">»Wir gingen langsam.«</p>
<p class="calibre1">»Ja, aber ich konnte auch kaum hören. Ich hörte euch gleich
darauf nicht mehr … Sag, was erwiderte mein Onkel, als du ihn
fragtest, wessen es zum Erfolg bedürfe?«</p>
<p class="calibre1">»Jerome,« sagte sie lachend, »du hast es ganz deutlich gehört!
Es macht dir Spaß, es noch einmal zu hören.«</p>
<p class="calibre1">»Ich versichere dir, daß ich nur den Anfang gehört habe …
als er von Zuversicht und Liebe sprach.«</p>
<p class="calibre1">»Er sagte nachher, daß es noch vieler anderer Dinge
bedürfe.«</p>
<p class="calibre1">»Aber du, was hattest du ihm geantwortet?«</p>
<p class="calibre1">Sie wurde plötzlich sehr ernst:</p>
<p class="calibre1">»Als er vom Halt im Leben sprach, erwiderte ich, du hättest
deine Mutter.«</p>
<p class="calibre1">»Alissa, du weißt recht wohl, daß ich sie nicht immer haben
werde … Und dann ist es auch nicht dasselbe …«</p>
<p class="calibre1">Sie senkte die Stirn:</p>
<p class="calibre1">»Das hat er mir auch zur Antwort gegeben.« <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page41" title="ECeDee/TBeaker"></a></p>
<p class="calibre1">Ich faßte sie zitternd bei der Hand.</p>
<p class="calibre1">»Was ich später auch werden mag, ich will es nur für dich
sein.«</p>
<p class="calibre1">»Aber Jerome, auch ich kann dich verlassen …«</p>
<p class="calibre1">Meine Seele floß in meine Worte:</p>
<p class="calibre1">»Ich, ich werde dich nie verlassen.«</p>
<p class="calibre1">Sie zuckte ein wenig die Achseln:</p>
<p class="calibre1">»Bist du nicht stark genug, um allein zu gehen! Ganz allein muß
ein jeder von uns zu Gott gelangen.«</p>
<p class="calibre1">»Aber du zeigst mir den Weg.«</p>
<p class="calibre1">»Weshalb willst du einen anderen Führer suchen als
Christus? … Glaubst du, wir seien einander jemals näher, als
wenn ein jeder von uns, den andern vergessend, zu Gott betet?«</p>
<p class="calibre1">»Ja, betet, uns zu vereinigen,« unterbrach ich sie; »darum bitte
ich ihn jeden Morgen und jeden Abend.«</p>
<p class="calibre1">»Verstehst du nicht, was die Vereinigung in Gott bedeuten
kann?«</p>
<p class="calibre1">»Ich verstehe es von ganzem Herzen: es heißt, sich verloren in
einem selben Angebeteten zu finden. Mir scheint, gerade um dich
<a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page42" title="ECeDee/Dieter7"></a> zu finden,
bete ich an, wovon ich weiß, daß auch du es anbetest.«</p>
<p class="calibre1">»Deine Anbetung ist nicht rein.«</p>
<p class="calibre1">»Verlange nicht zu viel von mir. Ich würde den Himmel verachten,
wenn ich nicht dich darin wiederfinden müßte.«</p>
<p class="calibre1">Sie legte einen Finger auf ihre Lippen und sagte ein wenig
feierlich:</p>
<p class="calibre1">»Suchet am ersten nach dem Reiche Gottes und seiner
Gerechtigkeit!«</p>
<p class="calibre1">Während ich diese Worte niederschreibe, bin ich mir wohl bewußt,
daß sie all jenen wenig kindlich erscheinen werden, die nicht
wissen, wie gern die Reden gewisser Kinder ernst werden. Was kann
ich daran ändern? Soll ich sie zu entschuldigen suchen? … So
wenig, wie ich sie schminken will, damit sie natürlicher
erscheinen.</p>
<p class="calibre1">Wir hatten uns im Text der Vulgata Evangelien verschafft und
kannten ganze Stellen daraus auswendig. Unter dem Vorwand, daß sie
ihrem Bruder helfen wollte, hatte Alissa mit mir lateinisch
gelernt: aber der Grund, so scheint mir, war eher der, daß <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page43" title="ECeDee/Dieter7"></a> sie mir auch
ferner in meiner Lektüre folgen wollte. Und sicherlich wagte ich
kaum an einem Studium Geschmack zu finden, in dem sie mich, wie ich
wußte, nicht begleiten würde. Wenn mich das bisweilen hemmte, so
geschah es nicht, wie man denken könnte, indem sie den Schwung
meines Geistes aufhielt; im Gegenteil schien es mir stets, daß sie
mir überallhin frei vorausflog. Aber mein Geist wählte seine Wege
ihr gemäß, und was uns damals beschäftigte, was wir »das Denken«
nannten, war oft nur ein Vorwand für eine verstiegenere
Vereinigung, nur eine Verkleidung der Empfindung, nur eine Hülle
der Liebe.</p>
<p class="calibre1">Meine Mutter hatte sich zunächst über eine Empfindung
beunruhigen können, deren Tiefe sie noch nicht zu ermessen
vermochte; aber jetzt, da sie ihre Kräfte schwinden fühlte, schien
sie uns in einer einzigen mütterlichen Umarmung zu vereinigen. Die
Herzkrankheit, an der sie seit langem litt, trug ihr immer
häufigere Leiden ein. Im Laufe einer besonders heftigen Krisis ließ
sie mich dicht zu sich treten: <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page44" title="ECeDee/Dieter7"></a></p>
<p class="calibre1">»Mein armer Kleiner, du siehst, ich altere sehr,« sagte sie zu
mir; »eines Tages werde ich dich ganz plötzlich verlassen.«</p>
<p class="calibre1">Sie verstummte sehr bedrückt. Unwiderstehlich mußte ich da das
rufen, was sie, wie es schien, aus meinem Munde erwartete:</p>
<p class="calibre1">»Mama … du weißt, ich will Alissa heiraten.« Und meine
Worte setzten ohne Zweifel ihre geheimsten Gedanken fort, denn sie
sagte alsbald:</p>
<p class="calibre1">»Ja, davon wollte ich mit dir reden, mein Jerome.«</p>
<p class="calibre1">»Mama,« fuhr ich schluchzend fort: »du glaubst, daß sie mich
liebt, nicht wahr?«</p>
<p class="calibre1">»Ja, mein Kind.« Sie wiederholte es mehrmals zärtlich: »Ja, mein
Kind.« Sie sprach mühsam und fügte hinzu: »Man muß es dem Herrn
überlassen.« Und als ich dicht vor ihr stand, den Kopf geneigt,
legte sie mir die Hand aufs Haar und sagte noch einmal:</p>
<p class="calibre1">»Gott behüte euch, meine Kinder! Gott behüte euch alle beide!«
Dann sank sie in eine Art Schlaftrunkenheit, aus der ich sie nicht
zu wecken suchte.</p>
<p class="calibre1">Diese Unterhaltung wurde nie wieder aufgenommen; <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page45" title="ECeDee/Dieter7"></a> am folgenden Tage fühlte
meine Mutter sich wohler, ich ging in meine Stunden, und das
Schweigen schloß sich wieder über dieser halben Aussprache. Was
hätte ich übrigens mehr erfahren sollen? Daß Alissa mich liebte,
daran konnte ich keinen Augenblick zweifeln. Und hätte ich es auch
bis dahin getan, so wäre der Zweifel bei dem traurigen Ereignis,
das folgte, auf ewig aus meinem Herzen geschwunden.</p>
<p class="calibre1">Meine Mutter erlosch eines Abends ganz sanft zwischen mir und
Miß Ashburton. Die letzte Krise, die sie hinübertrug, schien mir
zunächst nicht heftiger als die vorhergegangenen; sie nahm erst
gegen das Ende einen beängstigenden Charakter an; und keiner
unserer Verwandten hatte Zeit, vorher herbeizueilen. Neben der
alten Freundin meiner Mutter blieb ich in der ersten Nacht sitzen,
um bei der teuren Toten zu wachen. Ich liebte meine Mutter sehr,
und erstaunte, trotz meiner Tränen keine Trauer zu spüren; als ich
weinte, geschah es nur, weil Miß Ashburton mich jammerte, die ihre
um viele Jahre jüngere Freundin <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page46" title="Rsta/Dieter7"></a> so früher vor Gott hintreten sah. Aber der
geheime Gedanke, daß diese Trauer meine Freundin jäh zu mir jagen
müßte, beherrschte meinen Kummer mit ungeheurer Gewalt.</p>
<p class="calibre1">Am folgenden Tage traf mein Onkel ein. Er reichte mir einen
Brief seiner Tochter, die mit meiner Tante Plantier erst am dritten
Tage kam.</p>
<p class="calibre1">»Meine Not ist unerträglich,« schrieb sie darin … »Jerome,
mein Freund, mein Bruder! Wie trostlos bin ich, daß ich ihr nicht
vor ihrem Tode noch die wenigen Worte habe sagen können, die sie
erwartete. Jetzt mag sie mir vergeben! Und Gott allein leite uns
beide hinfort! Leb wohl, mein armer Freund. Ich bin zärtlicher als
je</p>
<p class="right">Deine Alissa.«</p>
<p class="calibre1">Was konnte dieser Brief bedeuten? Welches waren die Worte, die
nicht ausgesprochen zu haben sie trostlos war, wenn nicht die,
durch die sie unsere Zukunft gebunden hätte? – Ich war noch so
jung, daß ich trotzdem nicht gleich um ihre Hand zu bitten wagte.
Hatte ich übrigens ihr Versprechen noch nötig? Waren wir nicht
schon so gut wie verlobt? Unsere <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page47" title="Rsta/Dieter7"></a> Liebe war auch für unsere Umgebung kein
Geheimnis mehr; mein Onkel legte ihr so wenig wie meine Mutter
Hindernisse in den Weg. Im Gegenteil, er behandelte mich schon wie
seinen Sohn. Die Osterferien, die ein paar Tage darauf kamen,
verbrachte ich in Le Havre, wo ich bei meiner Tante Plantier wohnte
und fast all meine Mahlzeiten bei meinem Onkel Bucolin einnahm.</p>
<p class="calibre1">Meine Tante Plantier war die beste der Frauen; aber weder meine
Kusinen noch ich waren sehr vertraut mit ihr. Eine beständige
Geschäftigkeit brachte sie außer Atem; ihre Gesten waren ohne
sanfte Rundung; ihre Stimme ohne Melodie; sie stieß uns mit
Liebkosungen herum, die in irgendeinem Augenblick des Tages einem
Bedürfnis des Überströmens entflossen, in dem ihre Liebe zu uns aus
ihren Ufern trat. Mein Onkel Bucolin liebte sie sehr, aber allein
am Klang seiner Stimme, wenn er mit ihr sprach, konnten wir merken,
wie sehr viel lieber ihm meine Mutter gewesen war.</p>
<p class="calibre1">»Mein armes Kind,« begann sie eines Abends, »ich weiß nicht, was
du in diesem <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page48" title="Rsta/Dieter7"></a>
Sommer zu tun gedenkst; aber ich werde abwarten, bis ich deine
Pläne kenne, ehe ich mich darüber entscheide, was ich selbst
beginnen werde; wenn ich dir nützlich sein kann …«</p>
<p class="calibre1">»Ich habe noch nicht viel darüber nachgedacht,« erwiderte ich.
»Vielleicht werde ich versuchen, zu reisen.«</p>
<p class="calibre1">Sie fuhr fort: »Du weißt, daß du bei mir wie in Fongueusemare
stets willkommen sein wirst. Du wirst deinem Onkel und Juliette
eine Freude machen, wenn du zu ihnen hinunterkommst …«</p>
<p class="calibre1">»Du meinst, Alissa.«</p>
<p class="calibre1">»Ja, richtig! Entschuldige … Würdest du glauben, daß ich
mir eingebildet hatte, du liebtest Juliette? Bis dein Onkel mit mir
sprach … Es ist noch keinen Monat her … Du weißt, ich
liebe euch sehr, aber ich kenne euch nicht allzu genau; ich habe so
wenig Gelegenheit, euch zu sehen! … Und dann beobachte ich
auch nicht gut; ich habe keine Zeit, um stillzustehen und mir
anzusehen, was mich nichts angeht. Ich hatte dich immer nur mit
Juliette spielen sehen … Ich hatte mir gedacht … sie ist
so hübsch, so lustig.« <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page49" title="Erftschwabe/Dieter7"></a></p>
<p class="calibre1">»Ja, ich spiele immer noch gern mit ihr; aber Alissa liebe
ich …«</p>
<p class="calibre1">»Schön! Schön! Wie du willst … Ich, weißt du, da kann man
fast sagen, ich kenne sie nicht; sie spricht weniger als ihre
Schwester; ich denke mir, wenn du sie gewählt hast, so hast du
deinen guten Grund gehabt.«</p>
<p class="calibre1">»Aber, liebe Tante, es war nicht meine Wahl, daß ich sie liebte,
und ich habe mich nie gefragt, aus welchen Gründen ich …«</p>
<p class="calibre1">»Ärgere dich nicht, Jerome; ich rede ohne jede böse
Absicht … Jetzt habe ich richtig vergessen, was ich dir sagen
wollte … Ach ja: ich denke mir, wohlverstanden, daß all das
mit einer Heirat enden wird; aber wegen deiner Trauer kannst du
dich anständigerweise noch nicht verloben … und dann bist du
auch noch recht jung … Ich habe mir gedacht, jetzt, da du ohne
deine Mutter bist, möchte deine Anwesenheit in Fongueusemare nicht
gern gesehen werden …«</p>
<p class="calibre1">»Aber liebe Tante, gerade deshalb sprach ich von Reisen.«</p>
<p class="calibre1">»Ja. Nun, liebes Kind, ich habe mir gedacht, wenn auch ich da
wäre, so könnte das die <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page50" title="Erftschwabe/Dieter7"></a> Dinge erleichtern, und ich habe mich so
eingerichtet, daß ich einen Teil des Sommers hindurch frei
bin.«</p>
<p class="calibre1">»Wenn ich sie gebeten hätte, wäre Miß Ashburton gern
mitgekommen.«</p>
<p class="calibre1">»Ich weiß schon, daß sie kommen wird. Aber das genügt nicht! Ich
werde gleichfalls kommen … Oh, ich bin nicht so anmaßend, daß
ich dir deine arme Mutter ersetzen wollte,« fügte sie hinzu, indem
sie plötzlich schluchzte. »Aber ich würde mich um den Haushalt
kümmern – und schließlich sollst weder du, noch dein Onkel, noch
Alissa euch gestört fühlen.</p>
<p class="calibre1">Meine Tante Felicia irrte sich über die Wirksamkeit ihrer
Anwesenheit. Die Wahrheit zu sagen, so wurden wir nur durch sie
gestört. Wie sie es verkündigt hatte, richtete sie sich schon im
Juli zu Fongueusemare ein, wohin Miß Ashburton und ich ihr bald
folgten. Unter dem Vorwand, daß sie Alissa bei den häuslichen
Arbeiten helfen wollte, erfüllte sie dieses so ruhige Haus mit
einem beständigen Lärm.</p>
<p class="calibre1">Die Dienstfertigkeit, mit der sie uns angenehm <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page51" title="Erftschwabe/Dieter7"></a> sein und, wie sie es
ausdrückte, »die Dinge erleichtern« wollte, war so plump, daß
Alissa und ich in ihrer Gegenwart meist gezwungen und stumm
blieben.</p>
<p class="calibre1">Sie mußte uns recht kühl finden … – Und wenn wir nicht
geschwiegen hätten, hätte sie da die Art unserer Liebe begreifen
können? – Juliettes Charakter dagegen paßte sich diesem Schwall
vortrefflich an; und vielleicht hemmte ein Groll meine Liebe zu
meiner Tante, weil ich sah, daß sie der jüngeren ihrer Nichten eine
sehr ausgesprochene Vorliebe entgegenbrachte.</p>
<p class="calibre1">Eines Tages ließ sie mich nach dem Eintreffen der Post zu sich
kommen.</p>
<p class="calibre1">»Mein armer Jerome, ich bin ganz trostlos; meine Tochter ist
leidend und ruft mich; ich werde gezwungen sein, euch zu
verlassen …«</p>
<p class="calibre1">Geschwellt von unnötigen Bedenken suchte ich meinen Onkel auf,
denn ich wußte nicht mehr, ob ich wagen konnte, nach dem Aufbruch
meiner Tante noch in Fongueusemare zu bleiben. Aber gleich nach
meinen ersten Worten rief er: <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page52" title="Erftschwabe/Dieter7"></a></p>
<p class="calibre1">»Was hat meine arme Schwester sich da wieder ausgedacht, um die
natürlichsten Dinge zu verwickeln! Wie? Weshalb wolltest du uns
verlassen, Jerome? Bist du nicht fast schon mein Sohn?«</p>
<p class="calibre1">Meine Tante war kaum mehr als vierzehn Tage in Fongueusemare
geblieben. Sowie sie fort war, konnte das Haus sich wieder sammeln:
von neuem zog jene Heiterkeit darin ein, die so sehr dem Glück
glich. Meine Trauer hatte unsere Liebe nicht verdüstert, aber
gleichsam schwerer gemacht. Es begann ein Leben mit gleichförmigem
Lauf, darin wie in einem klangsteigernden Medium die geringste
Regung unserer Herzen zu hören war.</p>
<p class="calibre1">Ein paar Tage nach dem Aufbruch meiner Tante sprachen wir eines
Abends bei Tisch von ihr … Ich entsinne mich, daß wir
sagten:</p>
<p class="calibre1">»Welche Aufregung! Ist es möglich, daß die Fluten des Lebens
ihrer Seele nicht mehr Ruhe lassen? Schöner Schein der Liebe, was
wird hier aus deinem Widerglanz? …« – Denn wir entsannen uns
des Wortes von Goethe, der von Frau von Stein schrieb: »Es wäre
schön, die <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page53" title="Erftschwabe/Dieter7"></a> Welt sich in dieser Seele spiegeln zu
sehen.« Und wir errichteten auf der Stelle ich weiß nicht welche
Hierarchien, indem wir die kontemplativen Fähigkeiten am höchsten
stellten. Mein Onkel, der bis dahin geschwiegen hatte, unterbrach
uns mit einem traurigen Lächeln:</p>
<p class="calibre1">»Liebe Kinder,« sagte er, »selbst zerbrochen wird Gott sein Bild
noch wiedererkennen. Wir wollen uns hüten, die Menschen nach einem
einzigen Augenblick ihres Lebens zu beurteilen. Alles, was euch an
meiner armen Schwester mißfällt, verdankt sie Ereignissen, die ich
zu genau kenne, um sie so streng zu kritisieren, wie ihr es tut. Es
gibt keine noch so liebenswürdige Eigenschaft der Jugend, die nicht
mit dem Alter verderben kann. Was ihr bei Felicia Aufregung nennt,
war zunächst nichts als reizender Schwung, rasche Eingebung,
Hingabe an den Augenblick und Anmut … Wir waren nicht viel
anders, das versichere ich euch, als ihr heute erscheint. Ich glich
so ziemlich dir, Jerome; mehr vielleicht als ich weiß. Felicia
glich sehr stark dem, was jetzt Juliette ist … ja, sogar
körperlich – und <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page54" title="Erftschwabe/Dieter7"></a> plötzlich,« fügte er hinzu, indem er
sich zu seiner Tochter wandte, »erkenne ich sie in gewissen Klängen
deiner Stimme wieder; sie hatte dein Lächeln – und diese Geste, die
sie bald verlor, daß sie wie du oft plötzlich, ohne irgend etwas zu
tun, still dasaß, die Ellbogen vorgestützt, die Stirn in die
durchflochtenen Finger ihrer Hände gelegt.«</p>
<p class="calibre1">Miß Ashburton wandte sich zu mir und sagte mit fast flüsternder
Stimme:</p>
<p class="calibre1">»An deine Mutter erinnert Alissa.«</p>
<p class="calibre1">Der Sommer war in diesem Jahr wundervoll. Alles schien vom Blau
durchströmt. Unsere Glut triumphierte über das Übel, den Tod; der
Schatten wich vor uns zurück. An jedem Morgen weckte mich die
Freude; ich stand mit der Frühröte auf, stürzte mich dem Licht
entgegen … Wenn ich von dieser Zeit träume, sehe ich sie
voller Tau. Juliette stand früher auf als ihre Schwester, die den
Abend lange wachend hinzog, und ging mit mir in den Garten
hinunter. Zwischen ihrer Schwester und mir wurde sie zur Botin;
nicht endenwollend erzählte ich ihr von unserer Liebe, und <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page55" title="Erftschwabe/Dieter7"></a> sie schien
nicht müde zu werden, wenn sie mir lauschte. Ich sagte ihr, was ich
vor Alissa nicht zu sagen wagte, denn vor ihr wurde ich im Übermaß
meiner Liebe furchtsam und gezwungen. Alissa schien auf dieses
Spiel einzugehen, sich zu ergötzen, weil ich so lustig mit ihrer
Schwester sprach; und sie wußte nicht, oder tat, als wüßte sie
nicht, daß wir inzwischen nur von ihr sprachen.</p>
<p class="calibre1">O wunderbare Verstellung der Liebe, des Übermaßes selber der
Liebe, auf welchem heimlichen Wege führtest du uns vom Lachen zu
Tränen und von der naivsten Freude zur anspruchsvollen Strenge der
Tugend!</p>
<p class="calibre1">Der Sommer war so rein, so glatt, daß mein Gedächtnis heute von
jenen gleitenden Tagen fast nichts mehr zurückhalten kann. Die
einzigen Ereignisse waren Unterhaltungen, gelesene
Bücher …</p>
<p class="calibre1">»Ich habe einen traurigen Traum gehabt,« sagte mir Alissa am
Morgen eines meiner letzten Ferientage. – »Ich lebte, und du warst
tot. Nein, ich sah dich nicht sterben. Nur dieses eine stand fest:
du warst tot. Es war furchtbar; es war so unmöglich, daß ich mich
überredete, du <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page56" title="Erftschwabe/Dieter7"></a> seiest nur abwesend. Wir waren getrennt,
und ich fühlte, daß es ein Mittel gab, mich wieder mit dir zu
vereinigen; ich suchte nach dem Wie, und um es zu erreichen, machte
ich eine solche Anstrengung, daß sie mich weckte.</p>
<p class="calibre1">Heute morgen, glaube ich, blieb ich noch unter dem Eindruck
dieses Traumes stehen; es war, als setzte ich ihn fort. Mir war
immer noch, als sei ich von dir getrennt, als würde ich lange von
dir getrennt bleiben, lange …« Und sehr leise fügte sie hinzu:
»Mein ganzes Leben lang … und das ganze Leben lang müßte ich
eine große Anstrengung machen …«</p>
<p class="calibre1">»Wozu?«</p>
<p class="calibre1">»Wir beide, eine große Anstrengung, um wieder zueinander zu
kommen.«</p>
<p class="calibre1">Ich nahm ihre Worte nicht ernst oder fürchtete mich davor, sie
ernst zu nehmen. Wie um dagegen zu protestieren, sagte ich, während
mir das Herz in einem plötzlichen Mut heftig schlug:</p>
<p class="calibre1">»Nun, und ich, ich habe heute morgen geträumt, ich vermählte
mich dir so eng, daß uns nichts, nichts mehr trennen könnte – außer
dem Tod.« <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page57" title="Erftschwabe/Dieter7"></a></p>
<p class="calibre1">»Du glaubst, der Tod könne trennen?« fragte sie.</p>
<p class="calibre1">»Ich meine …«</p>
<p class="calibre1">»Ich glaube, er kann eher nähern … ja, nähern, was im Leben
getrennt war.«</p>
<p class="calibre1">All das drang so tief in uns ein, daß ich selbst den Ton ihrer
Worte noch höre. Und doch begriff ich ihren ganzen Ernst erst
später.</p>
<p class="calibre1">Der Sommer floh. Schon waren die meisten Felder leer, und der
Blick flog unverhofft freier darüber hin. Am letzten, nein, am
vorletzten Abend vor meiner Abreise ging ich mit Juliette in das
Gehölz des Untergartens hinab.</p>
<p class="calibre1">»Was zitiertest du Alissa gestern?« fragte sie.</p>
<p class="calibre1">»Wann denn?«</p>
<p class="calibre1">»Auf der Bank der Mergelgrube, als wir euch hinter uns gelassen
hatten.«</p>
<p class="calibre1">»Ah … ein paar Verse von Baudelaire, glaube ich.«</p>
<p class="calibre1">»Welche? … Willst du sie mir nicht sagen? …«</p>
<p class="calibre1">»› <i class="calibre5">Bald werden wir ins kalte Dunkel <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page58" title="Erftschwabe/Dieter7"></a> tauchen</i>‹« begann ich
ziemlich widerwillig; aber sie unterbrach mich auf der Stelle und
fuhr mit zitternder und veränderter Stimme fort:</p>
<p class="calibre1">»› <i class="calibre5">Leb wohl, zu kurzer Sommer scharfe Helle</i>‹«</p>
<p class="calibre1">»Wie, du kennst sie?« rief ich in höchster Überraschung. »Ich
glaubte, du möchtest keine Verse …«</p>
<p class="calibre1">»Weshalb denn? Etwa, weil du mir keine vorsagst?« erwiderte sie
lachend, aber ein wenig verlegen … »Mitunter ist es, als
hieltest du mich für vollständig borniert.«</p>
<p class="calibre1">»Man kann sehr intelligent sein, ohne darum Verse zu mögen.
Niemals habe ich dich welche hersagen hören und nie hast du mich
gebeten, dir welche zu nennen.«</p>
<p class="calibre1">»Weil Alissa das übernimmt …« Sie verstummte auf einige
Augenblicke; dann unvermittelt:</p>
<p class="calibre1">»Übermorgen reist du?«</p>
<p class="calibre1">»Ich muß.«</p>
<p class="calibre1">»Was wirst du diesen Winter beginnen?«</p>
<p class="calibre1">»Es ist mein erstes Seminarjahr.«</p>
<p class="calibre1">»Wann denkst du Alissa zu heiraten?«</p>
<p class="calibre1">»Nicht vor meinem Militärdienst. Nicht einmal, <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page59" title="Erftschwabe/Dieter7"></a> bevor ich nicht ein
wenig genauer weiß, was ich nachher beginnen will.«</p>
<p class="calibre1">»Du weißt es also noch nicht?«</p>
<p class="calibre1">»Ich will es noch nicht wissen. Mich interessieren zu viele
Dinge. Ich schiebe den Augenblick, in dem ich wählen muß, um dann
nur noch eins zu tun, so lange wie möglich hinaus.«</p>
<p class="calibre1">»Schiebst du deine Verlobung auch aus Furcht vor der
Entscheidung hinaus?«</p>
<p class="calibre1">Ich zuckte die Achseln, ohne zu antworten. Sie blieb dabei:
»Worauf wartet ihr denn, um euch zu verloben? Weshalb verlobt ihr
euch nicht gleich?«</p>
<p class="calibre1">»Aber weshalb sollten wir uns verloben? Genügt es nicht, wenn
wir wissen, daß wir einander gehören und gehören werden, wenn auch
die Welt nichts davon erfährt? Wenn es mir gefällt, mein ganzes
Leben für sie zu verpfänden, würdest du es da schöner finden, wenn
ich meine Liebe durch Versprechungen bände? Ich nicht. Gelübde
würden mir als eine Beschimpfung der Liebe erscheinen … Ich
würde mich nur verloben wollen, wenn ich ihr mißtraute …«</p>
<p class="calibre1">»Nicht ihr mißtraue ich …« <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page60" title="Erftschwabe/Dieter7"></a></p>
<p class="calibre1">Wir gingen langsam; wir waren bis zu jenem Punkt des Gartens
gekommen, an dem ich jüngst unfreiwillig der Unterhaltung Alissas
mit ihrem Vater gelauscht hatte. Mir kam plötzlich der Gedanke, daß
vielleicht Alissa, die ich in den Garten hatte hinausgehen sehen,
im Rondell säße, und daß sie auch uns hören könnte; die
Möglichkeit, sie vernehmen zu lassen, was ich ihr direkt nicht zu
sagen wagte, verführte mich auf der Stelle; belustigt durch meine
List erhob ich die Stimme und rief mit jener ein wenig pomphaften
Begeisterung meines Alters, indem ich viel zu sehr auf meine
eigenen Worte achtete, als daß ich durch die Juliettes hindurch
hätte hören können, was sie nicht aussprach:</p>
<p class="calibre1">»Oh! Wenn wir nur, indem wir uns über die Seele neigen, die wir
lieben, in ihr wie in einem Spiegel sehen könnten, welches Bild wir
ihr aufprägen! In anderen lesen wie in uns selber, besser als in
uns selber! Welche Ruhe in der Zärtlichkeit! Welche Sicherheit im
Handeln! Welche Reinheit in der Liebe! …«</p>
<p class="calibre1">Ich war Narr genug, um Juliettens Verwirrung für eine Wirkung
meines mittelmäßigen <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page61" title="Erftschwabe/Dieter7"></a> Schwungs zu halten. Sie barg plötzlich
den Kopf auf meiner Schulter:</p>
<p class="calibre1">»Jerome! Jerome! Ich möchte sicher sein, daß du sie glücklich
machen wirst! Wenn sie auch durch dich noch leiden müßte, ich
glaube, ich würde dich verabscheuen!«</p>
<p class="calibre1">»Aber, Juliette,« rief ich, indem ich sie umarmte und ihre Stirn
emporhob, »ich würde mich selber verabscheuen. Wenn du
wüßtest! … Aber nur, um erst mit ihr mein Leben besser zu
beginnen, will ich noch nicht über meine Laufbahn entscheiden; ich
lasse meine ganze Zukunft um ihretwillen unentschieden! Alles, was
ich ohne sie sein könnte, will ich nicht …«</p>
<p class="calibre1">»Was sagt sie, wenn du mit ihr darüber redest?«</p>
<p class="calibre1">»Aber ich rede niemals mit ihr darüber! Niemals; auch aus diesem
Grunde verloben wir uns noch nicht; nie ist zwischen uns von einer
Heirat die Rede, noch auch von dem, was wir später tun werden. – O
Juliette! Das Leben mit ihr scheint mir so schön, daß ich nicht
wage … verstehst du das? Daß ich nicht wage, mit ihr darüber
zu reden?«</p>
<p class="calibre1">»Du willst, daß das Glück sie überrascht …« <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page62" title="Erftschwabe/Dieter7"></a></p>
<p class="calibre1">»Nein, das ist es nicht. Aber ich fürchte mich … ihr Furcht
einzuflößen, verstehst du? … Ich fürchte, daß dieses
ungeheuere Glück, das ich ahne, sie beängstige. – Eines Tages habe
ich mit ihr von Reisen gesprochen; ich fragte sie, ob sie zu reisen
wünschte. Sie sagte mir, sie wünsche nichts, und es genüge ihr, zu
wissen, daß es jene Länder gebe, daß sie schön seien, und daß
andere sie besuchen dürften …«</p>
<p class="calibre1">»Und du, Jerome, du möchtest reisen?«</p>
<p class="calibre1">»Überallhin. Das ganze Leben erscheint mir als eine lange Reise
– mit ihr, als eine Reise durch Bücher, Menschen und Länder …
Denkst du wohl daran, was diese Worte bedeuten: die Anker
lichten?«</p>
<p class="calibre1">»Ja, ich denke oft daran,« murmelte sie; aber ich, der ich kaum
auf sie hörte und ihre Worte wie kleine, verwundete Vögel zu Boden
fallen ließ, fuhr fort:</p>
<p class="calibre1">»Aufbrechen, nachts; erwachen in der Blendung der Morgenröte;
sich zu zweit allein auf der Unsicherheit der Wogen
fühlen …«</p>
<p class="calibre1">»Und die Ankunft in einem Hafen, den man als Kind schon auf den
Karten betrachtet hat und wo alles unbekannt ist … Ich stelle
mir <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page63" title="ECeDee/Dieter7"></a> vor,
wie du das Schiff verläßt und über den Landesteg gehst, Alissa auf
deinen Arm gestützt.«</p>
<p class="calibre1">»Dann gehen wir schnell auf die Post,« fügte ich lachend hinzu,
»um den Brief zu holen, den Juliette uns geschrieben
hat …«</p>
<p class="calibre1">»Von Fongueusemare, wo sie geblieben ist und das euch ganz
klein, ganz traurig und ganz fern erscheinen wird …«</p>
<p class="calibre1">Sind das ihre genauen Worte? Ich kann es nicht behaupten, denn,
wie ich schon sagte, ich war von meiner Liebe so erfüllt, daß ich
neben ihr kaum noch einen anderen Ausdruck hörte als den
ihrigen.</p>
<p class="calibre1">Wir kamen zum Rondell; wir wollten umkehren, als plötzlich aus
dem Schatten hervor Alissa sich zeigte. Sie war so bleich, daß
Juliette aufschrie.</p>
<p class="calibre1">»Ich fühle mich wirklich nicht sehr wohl,« stammelte Alissa
hastig. »Die Luft ist frisch. Ich glaube, ich täte besser daran,
hineinzugehen.« Und sie verließ uns alsbald und kehrte mit raschem
Schritt zum Hause zurück.</p>
<p class="calibre1">»Sie hat alles gehört, was wir sagten,« rief Juliette, sowie
Alissa sich ein wenig entfernt hatte. <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page64" title="ECeDee/Dieter7"></a></p>
<p class="calibre1">»Aber wir haben nichts gesagt, was ihr weh tun könnte. Im
Gegenteil …«</p>
<p class="calibre1">»Laß mich,« sagte sie, indem sie ihrer Schwester
nachstürzte.</p>
<p class="calibre1">In jener Nacht konnte ich nicht schlafen. Alissa war bei Tisch
erschienen und hatte sich bald darauf zurückgezogen, indem sie sich
über Kopfschmerzen beklagte. Was hatte sie von unserer Unterhaltung
gehört? Und ich besann mich besorgt auf unsere Worte. Dann dachte
ich, daß ich vielleicht unrecht daran getan hätte, als ich zu dicht
neben Juliette herging, meinen Arm um sie zu schlingen; aber das
war eine Kindergewohnheit, und manches Mal schon hatte uns Alissa
so gehen sehen. Ah, was für ein trauriger Blinder ich war, als ich
tastend nach meinem Unrecht suchte und nicht einen Augenblick daran
dachte, daß Juliettes Worte, denen ich so schlecht zugehört hatte,
vielleicht bei Alissa besseres Gehör gefunden haben mochten.
Einerlei! Irre geführt durch meine Unruhe, entsetzt ob des
Gedankens, daß Alissa an mir zweifeln könnte, entschloß ich mich,
zumal ich mir keine andere Gefahr vorstellte, und trotz all <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page65" title="ECeDee/Dieter7"></a> dessen, was ich
Juliette darüber hatte sagen können, vielleicht sogar beeindruckt
durch das, was sie mir gesagt hatte, meine Bedenken, meine
Befürchtung zu überwinden und mich am folgenden Tage zu
verloben.</p>
<p class="calibre1">Es war am Tage vor meinem Aufbruch. Diesem Umstand konnte ich
ihre Trauer zuschreiben. Mir schien, als miede sie mich. Der Tag
verstrich, ohne daß ich sie hatte allein treffen können; die Furcht
davor, abreisen zu müssen, ohne sie gesprochen zu haben, trieb mich
ein paar Augenblicke vor der Hauptmahlzeit bis in ihr Zimmer; sie
legte sich ein Korallenhalsband um und hob die Arme und neigte sich
vor, um es zu befestigen, wobei sie der Tür den Rücken wandte und
über die Schulter weg zwischen zwei Kerzen in einen Spiegel
blickte. Im Spiegel sah sie mich zuerst; und ein paar Augenblicke
lang sah sie mich so an, ohne sich zu wenden.</p>
<p class="calibre1">»Ach, war meine Tür denn nicht verschlossen?« fragte sie.</p>
<p class="calibre1">»Ich habe geklopft – du gabst keine Antwort. Alissa – du weißt,
daß ich morgen reise?« <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page66" title="ECeDee/Dieter7"></a></p>
<p class="calibre1">Sie erwiderte nichts, sondern legte das Halsband, das zu
befestigen ihr nicht gelang, auf den Kamin. Da mir das Wort
Verlobung zu nackt, zu brutal schien, gebrauchte ich statt dessen
ich weiß nicht mehr welche Umschreibung. Sowie Alissa mich begriff,
war es mir, als schwankte sie, als stützte sie sich am Kamin …
aber ich selber zitterte so sehr, daß ich es schüchtern vermied,
nach ihr zu sehen.</p>
<p class="calibre1">Ich stand dicht bei ihr, und ohne die Augen zu heben, ergriff
ich sie bei der Hand; sie machte sich nicht los; aber indem sie ihr
Gesicht ein wenig neigte und meine Hand ein wenig hob, drückte sie
die Lippen darauf und murmelte, halb an mich gelehnt:</p>
<p class="calibre1">»Nein, Jerome, nein, wir wollen uns nicht verloben, ich bitte
dich …«</p>
<p class="calibre1">Mir pochte das Herz so stark, daß ich glaubte, sie müßte es
fühlen; sie fuhr nur zärtlicher fort:</p>
<p class="calibre1">»Nein, noch nicht …«</p>
<p class="calibre1">Und als ich fragte: »Weshalb?«</p>
<p class="calibre1">»Aber eigentlich kann ich dich fragen: weshalb? Weshalb etwas
ändern?«</p>
<p class="calibre1">Ich wagte nicht, ihr etwas von der Unterhaltung des
vorhergehenden Tages zu sagen; aber <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page67" title="ECeDee/Dieter7"></a> ohne Zweifel fühlte sie, daß ich daran
dachte, und wie zur Antwort auf meinen Gedanken sagte sie, indem
sie mich fest ansah:</p>
<p class="calibre1">»Du irrst dich, mein Freund: Ich habe soviel Glück nicht nötig.
– Sind wir so nicht glücklich?«</p>
<p class="calibre1">Sie bemühte sich vergebens, zu lächeln.</p>
<p class="calibre1">»Nein, da ich dich verlassen muß.«</p>
<p class="calibre1">»Höre, Jerome, ich kann heute abend nicht mit dir
sprechen … Wir wollen uns nicht die letzten Augenblicke
verderben … Nein, nein. Ich liebe dich so sehr wie nur je;
beruhige dich. Ich werde dir schreiben; ich werde dir alles
erklären. Ich verspreche, dir zu schreiben; gleich morgen …
Sowie du fort bist. Geh jetzt! Sieh, da weine ich schon … Laß
mich allein.«</p>
<p class="calibre1">Sie stieß mich zurück, entzog sich mir sanft – und das war unser
Abschied; denn an diesem Abend konnte ich ihr nichts mehr sagen,
und am folgenden Tage schloß sie sich in dem Augenblick meines
Aufbruchs in ihrem Zimmer ein. Ich sah, wie sie mir von ihrem
Fenster ein Lebewohl nachwinkte, während sie zusah, wie mein Wagen
davonzog. <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page68" title="ECeDee/Dieter7"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?290b3bd0